import { UINode } from '@larva.io/clouddevice';
import * as LarvaWebComponents from '@larva.io/webcomponents-react';
import { pascalize } from 'core/utils/stringUtils';
import { UINodeLocal } from '../types/UINodeLocal';

const sortAndFilterUINodes = (nodes: UINodeLocal[], favorites?: boolean): UINodeLocal[] =>
    nodes
        // filter nodes that should be visible
        .filter((e: UINode) => e.ui.visible)
        .filter((e: UINode) => (!!favorites ? e.ui.favorite : true))
        // filter out nodes that doesn't have WebComponent
        .filter((item: UINode) => {
            return pascalize(item.node.type) in LarvaWebComponents;
        });

export default sortAndFilterUINodes;
